import React, { lazy } from "react";
import { Link } from "react-router-dom";
import { ModalRoute, LazyModalRoute, LazyComponent } from "seed/helpers";
import l from "components/util/l";
import HelpMessage from 'components/util/helpers/HelpMessage';
import StyleColor from "components/util/helpers/StyleColor"
import Collaboration from "components/presentation/forms/collaboration/Collaboration";
import ChatNotifications from "components/presentation/chat/ChatNotifications";
import SidenavItem from "components/presentation/Presentation.sub.SidenavItem.view";
import Settings from "components/presentation/settings/Settings";
import History from "components/presentation/history/History";
import Preview from "components/presentation/chat/Preview"
import Studio from "components/presentation/flow/Studio"
import NotificationsBell from "components/vmisc/notifications/NotificationsBell";
import CopyClipboardButton from "components/util/helpers/CopyClipboardButton";
import CustomView from "components/presentation/settings/CustomView";
import RegisterMarquee from "components/vmisc/onboarding/RegisterMarquee";
import ProfileIcon from "components/util/helpers/ProfileIcon";
import "styles/css/presentation/Presentation.css";

const FlowValidator = lazy(() => import("components/vmisc/flow_validator/FlowValidator"));
const FlowFormCreate = lazy(() => import("components/presentation/forms/flows/FlowFormCreate"));
const FlowFormEdit = lazy(() => import("components/presentation/forms/flows/FlowFormEdit"));
const FolderFormCreate = lazy(() => import("components/presentation/forms/folders/FolderFormCreate"));
const FolderFormEdit = lazy(() => import("components/presentation/forms/folders/FolderFormEdit"));
const Collections = lazy(() => import("components/collections/Collections"));


const PresentationView = ({
  user,
  flows,
  flow,
  showSidenav,
  showShare,
  showManageCollections,
  chatPermissions,
  selectedNote,
  chatRef,
  notesRef,
  presentationSettings,
  activeSection,
  userRole,
  userUsage,
  isAdmin,
  isDeveloper,
  chat,
  currentChat,
  refreshFlow,
  refreshChat,
  onClickChangeChat,
  onClickResumeChat,
  onClickSelectNote,
  onClickTab,
  onClickLogo,
  onChangeFlow,
  onCreateFlow
}) => (
  <div>
    <StyleColor theme={flow.theme} backgroundHeight="0vh" />
    {user?.isAnonymous == true && (<RegisterMarquee />)}
    <div id="presentation-mode" className="d-flex">


      <div id="presentation-sidenav"
        className="d-flex flex-row flex-sm-column h-100">

        <div class="sidenav-header w-auto ml-1 d-flex align-items-center">
          <a onClick={() => onClickLogo()}>
            <div className="logo" style={flow.theme.logo ? { backgroundImage: `url(${flow.theme.logo})` } : {}}></div>
          </a>
        </div>

        <label className="flow-selector-title dropdown-header px-0 pt-3">
          Soluciones
        </label>

        <select className="flow-selector"
          value={flow.id}
          onChange={(e) => onChangeFlow(e.target.value)}>
          {flows.map(flow => <option key={flow.id} value={flow.id}>{flow.name}</option>)}
          <option value={"create"}>+ Crear solución</option>
        </select>

        <div className="sidenav-menu">
          {
            (presentationSettings?.views ?? [])
              .filter(v => !v.is_hidden)
              .filter((view) => {
                const permsKey = `show_${view.name}`;
                return isAdmin || (chatPermissions[permsKey]?.[userRole.id] ?? true);
              })
              .map((view, index, array) =>
                <div key={view.name}
                  className="d-flex flex-sm-column">
                  <SidenavItem
                    name={view.name}
                    label={view.is_prebuilt ? l(view.label) : view.label}
                    icon={getViewIcon[view.name] || view.icon || "fas fa-window-maximize"}
                    activeSection={activeSection}
                    onClickItem={onClickTab} />
                  {index % 3 == 2 && index < array.length - 1 &&
                    <div className="sidenav-divider" />}
                </div>
              )
          }
        </div>

      </div>

      <div id="presentation-container" className="h-100 w-100">

        <div id="presentation-header"
          className={"d-flex w-100 justify-content-between align-items-center"}>

          <div id="presentation-title" class="d-flex align-items-center">

            <div className="ml-1 my-0">
              <span className="flow-title-container d-flex align-items-center text-hover-primary">
                <Link className="h2 flow-title d-flex align-items-center mb-0"
                  to={`/edit_flow`}>
                  <div className="flow-name d-flex align-items-center">
                    <span className="text-truncate">{flow.name}</span>
                  </div>
                  <div class="py-1 flow-edit-btn rounded">
                    <i class="fa-solid fa-pen"></i>
                  </div>
                </Link>
              </span>
            </div>

          </div>

          <div id="presentation-actions" className="d-flex">

            <span className="d-flex align-items-center">

              <NotificationsBell
                flow={flow}
              />

              {
                (isAdmin || (showShare[userRole.id] ?? true)) &&
                <HelpMessage message={l("Comparte tu solución con otras personas para colaborar%PA100")}
                  style={{ marginTop: "-5px", maxWidth: "14rem" }}>
                  <Link to="/share" className="btn btn-sm btn-accent py-2 px-2 px-sm-3 mr-2 share-button font-weight-bold">
                    <i class="fas fa-upload mr-1"></i> {l("Publicar")}
                  </Link>
                </HelpMessage>
              }
              <div class="dropdown">
                <div className="profile-button dropdown-toggle d-none"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <ProfileIcon style={{ width: "100%", height: "100%" }} />
                </div>

                <div class="dropdown-menu pr-1">
                  <Link to={`/settings/account`} class="dropdown-item">
                    <i class="fas fa-user dropdown-item-icon mr-1"></i> {l("Perfil")}
                  </Link>
                  <Link to={`/settings/plan`} class="dropdown-item">
                    <i class="fas fa-money-bill dropdown-item-icon mr-1"></i> {l("Plan y facturación")}
                  </Link>
                  <Link to={`/settings/flows`} class="dropdown-item">
                    <i class="fas fa-layer-group dropdown-item-icon mr-1"></i> {l("Soluciones")}
                  </Link>

                  <hr className="my-2" />
                  {["ENTERPRISE"].includes(userUsage?.license?.category?.name) || isDeveloper ? (
                    <li className="nav-item">
                      <Link to="/organizations" className="dropdown-item">
                        <i className="fas fa-building dropdown-item-icon mr-1"></i>{l("Organización%SB017")}
                      </Link>
                    </li>
                  ) : null}
                  <Link to={`/settings/customization`} class="dropdown-item">
                    <i class="fas fa-cog dropdown-item-icon mr-1"></i> {l("Ajustes")}
                  </Link>
                  <a href={`/logout`} class="dropdown-item">
                    <i class="fas fa-sign-out dropdown-item-icon mr-1"></i> {l("Cerrar sesión")}
                  </a>
                </div>

              </div>
            </span>

          </div>
        </div>

        <div id="presentation-content">

          {
            getViewComponent({
              chatRef,
              notesRef,
              flow,
              chat,
              userRole,
              selectedNote,
              currentChat,
              isAdmin,
              isDeveloper,
              showManageCollections,
              refreshChat,
              refreshFlow,
              onClickTab,
              onClickChangeChat,
              onClickResumeChat,
              onClickSelectNote
            },
              presentationSettings?.views ?? [],
              activeSection
            )
          }

          {/*
            function () {

              let returnViews = [];
              const mainSections = presentationSettings?.views
                ?.filter(view => view.is_main);

              mainSections.forEach((view) => {
                const permsKey = `show_${view.name}`;
                if (isAdmin || (chatPermissions[permsKey]?.[userRole.id] ?? true))
                  returnViews.push({
                    component: getViewComponent({
                      chatRef,
                      notesRef,
                      flow,
                      chat,
                      userRole,
                      selectedNote,
                      currentChat,
                      isAdmin,
                      isDeveloper,
                      showManageCollections,
                      closeNav,
                      refreshChat,
                      refreshFlow,
                      onClickTab,
                      onClickChangeChat,
                      onClickResumeChat,
                      onClickSelectNote
                    }, presentationSettings?.views ?? [], view),
                    weight: view?.settings?.weight,
                    position: view?.settings?.position,
                    name: view?.name
                  });
              });

              returnViews.sort((a, b) => {
                if (a?.position === "left" && b?.position !== "left") return -1;
                if (a?.position !== "left" && b?.position === "left") return 1;
                return 0;
              });

              if (returnViews.length == 2 && window.innerWidth > 570) {
                return (
                  <div className="d-flex h-100">
                    <div id="presentation-main-left-section" className="presentation-main-section position-relative"
                      style={{ width: `${returnViews[0].weight ?? 50}%` }}>
                      <div className={"card presentation-main-wrapper " + returnViews[0].name}>
                        {returnViews[0].component}
                      </div>
                    </div>
                    <div id="presentation-main-right-section" className="presentation-main-section position-relative"
                      style={{ width: `${returnViews[1].weight ?? 50}%` }}>
                      <div className={"card presentation-main-wrapper " + returnViews[1].name}>
                        {returnViews[1].component}
                      </div>
                    </div>
                  </div>
                );
              }
              else if (returnViews.length > 0) {
                return <div id="presentation-main-section" className="presentation-main-section">
                  <div className={"card presentation-main-wrapper " + returnViews[0].name}>
                    {returnViews[0].component}
                  </div>
                </div>
              }
              else {
                return getViewComponent({
                  chatRef,
                  notesRef,
                  flow,
                  chat,
                  userRole,
                  selectedNote,
                  currentChat,
                  isAdmin,
                  isDeveloper,
                  showManageCollections,
                  closeNav,
                  refreshChat,
                  refreshFlow,
                  onClickTab,
                  onClickChangeChat,
                  onClickResumeChat,
                  onClickSelectNote
                }, presentationSettings?.views ?? [], { name: "ai" });
              }

            }()
          */}

          <ChatNotifications flow={flow} />

        </div>

      </div>



    </div>

    {(isAdmin || (showShare[userRole.id] ?? true)) ?
      <LazyModalRoute
        width={850}
        height={600}
        animation={""}
        path="/share"
        component={() => <Collaboration flowId={flow.id} />}
      /> : null}

    {isAdmin ?
      <LazyModalRoute
        width="520"
        height="500"
        path="/edit_flow"
        component={() =>
          <FlowFormEdit
            match={{ params: { "flowId": flow.id } }}
          />
        }
      /> : null}

    <LazyModalRoute
      width="1000"
      height="800"
      path="/create_flow"
      component={({ match }) =>
        <FlowFormCreate match={match}
          onSave={onCreateFlow} />}
    />

    <LazyModalRoute
      width="450"
      height="450"
      path="/create_folder"
      component={() => <FolderFormCreate />}
    />

    <LazyModalRoute
      width="450"
      height="450"
      path="/edit_folder"
      component={({ match }) => <FolderFormEdit match={match} />}
    />

    <LazyModalRoute
      path="/flow_validation/:flowId"
      width={window.innerWidth - 100}
      height={window.innerHeight - 50}
      flow={flow}
      component={FlowValidator}
    />

    <ModalRoute
      path="/views/:name"
      width={window.innerWidth - 100}
      height={window.innerHeight - 50}
      component={({ match }) =>
        <div className="card card-body h-100 p-1 bg-white">
          {
            (presentationSettings?.views ?? []).map((view, index) => (
              view.name == match.params?.name ?
                <iframe
                  key={`custom_view_${index}`}
                  className="w-100 h-100 border-0"
                  src={decodeURIComponent(view.url ?? "")}
                  title={view.name}
                ></iframe> : null
            ))
          }
        </div>}
    />

    <ModalRoute
      width={750}
      height={window.innerHeight - 150}
      animation={""}
      path="/flow/website/:url"
      component={({ match }) => <div className="card w-100 h-100">
        <div className="w-100 text-center py-2">{l("Liga para compartir%PA105")}:&nbsp;
          <a href={decodeURIComponent(match.params?.url)} target="_blank" rel="noreferrer">{decodeURIComponent(match.params?.url)}</a>
          <CopyClipboardButton link={decodeURIComponent(match.params?.url)} />
        </div>
        <iframe className="w-100 h-100"
          src={decodeURIComponent(match.params?.url)}
          referrerpolicy="same-origin" title="website" />
      </div>}
    />

  </div>
)

const getViewIcon = {
  "ai": "fas fa-message",
  "processes": "fas fa-project-diagram",
  "data": "fas fa-table",
  "model": "fas fa-brain",
  "history": "fas fa-clock-rotate-left",
  "settings": "fas fa-cog",
}

const getViewComponent = ({
  chatRef,
  notesRef,
  flow,
  chat,
  userRole,
  selectedNote,
  currentChat,
  isAdmin,
  isDeveloper,
  showManageCollections,
  refreshChat,
  refreshFlow,
  onClickTab,
  onClickChangeChat,
  onClickResumeChat,
  onClickSelectNote,
}, views, currentView) => {

  const components = {
    "ai": {
      "component": Preview,
      "props": {
        ref: chatRef,
        notesRef,
        flow,
        chat,
        selectedNote,
        currentChat,
        onClickTab,
        onClickChangeChat,
        onClickResumeChat
      }
    },
    "processes": {
      "component": Studio,
      "props": {
        flow,
        userRole,
        isAdmin,
        isDeveloper,
        refreshChat
      }
    },
    "data": {
      "component": Collections,
      "isLazy": true,
      "props": {
        flow: flow,
        userRole,
        isAdmin,
        showManageCollections,
      }
    },
    "history": {
      "component": History,
      "props": {
        notesRef,
        flow,
        chat,
        selectedNote,
        onClickChangeChat,
        onClickSelectNote,
        isAdmin,
      }
    },
    "settings": {
      "component": Settings,
      "props": {
        flow,
        chat,
        refreshFlow,
        refreshChat,
        isAdmin,
      }
    }
  }

  if (currentView.name in components) {
    const Component = components[currentView.name].component;
    const props = { ...components[currentView.name].props, currentView };
    const isLazy = components[currentView.name].isLazy
    if (isLazy) return <LazyComponent {...props} component={Component} />
    return <Component {...props} />;
  }

  const customActiveView = views.find(view => view.name === currentView.name);
  if (!customActiveView) return;

  return <CustomView
    flowId={flow.id}
    customView={customActiveView}
  />

}

export default PresentationView;